import { Link } from 'gatsby';
import React, { PropsWithChildren } from 'react';

import { linkHasSVG } from '../../../helpers/list-page/type-guards';
import { useCalculateSlug } from '../../../hooks/use-calculate-slug';
import { IMeetingPlaceLinkToAnyPage } from '../../../queries/fragments/meetingPlaceLinkToAnyPage';

type LinkWrapperProps = {
  data: string | IMeetingPlaceLinkToAnyPage;
  className?: string;
  target?: string;
  rel?: string;
  itemProp?: string;
  onClick?: () => void;
};

const LinkWrapper = ({
  children,
  data,
  target,
  rel,
  className,
  itemProp,
  onClick,
}: PropsWithChildren<LinkWrapperProps>) => {
  const isLinkToAnyPage = (
    link: IMeetingPlaceLinkToAnyPage | string,
  ): link is IMeetingPlaceLinkToAnyPage => {
    return (
      typeof link !== 'string' &&
      '__typename' in (link as IMeetingPlaceLinkToAnyPage)
    );
  };

  const isExternalLink = (link: IMeetingPlaceLinkToAnyPage): boolean => {
    return 'linkHref' in link;
  };

  const linkHref = useCalculateSlug(data);
  const getExternalLinkTarget = (link: IMeetingPlaceLinkToAnyPage) => {
    return link.linkTarget === 'New'
      ? { target: '_blank', rel: 'noopener noreferrer' }
      : {};
  };

  const linkRel = rel ? { rel } : {};
  const linkItemProp = itemProp ? { itemProp } : {};
  const linkTarget = target ? { target } : {};
  const linkHasSvg = linkHasSVG(data);

  if (isLinkToAnyPage(data) && isExternalLink(data)) {
    return (
      <a
        className={`mb-3  ${
          linkHasSvg ? 'flex' : 'block'
        } hover:text-text-light hover:underline`}
        href={data.linkHref}
        {...getExternalLinkTarget(data)}
      >
        {linkHasSvg && (
          <img
            src={data.linkSvg?.file?.url}
            height={16}
            width={16}
            className="h-4"
          />
        )}
        {children}
      </a>
    );
  }

  return (
    <Link
      onClick={() => onClick?.()}
      to={linkHref}
      className={className}
      {...linkTarget}
      {...linkRel}
      {...linkItemProp}
    >
      {children}
    </Link>
  );
};

export default LinkWrapper;
